export default {"src":"/_next/static/media/instagram.199fa6e6.svg","height":16,"width":16};